import React, { useMemo } from 'react';
import StepsProvider from 'providers/Steps/Steps.provider';
import { Outlet } from 'react-router';
import ListingCreationStepper from '../../../../../components/ListingCreationStepper';
import routes from './routes';
import ListingEditStepWrapper from '../../../components/ListingEditStepWrapper';

const UnderExternalAdministration: React.FC = () => {
  const stepperRoutes = useMemo(
    () => routes.filter(({ labelId }) => labelId),
    [],
  );

  return (
    <StepsProvider
      steps={stepperRoutes}
      storageKeySuffix="listing-creation-wizard-steps"
      completedSteps={stepperRoutes.length}
    >
      <ListingEditStepWrapper>
        <ListingCreationStepper />

        <Outlet />
      </ListingEditStepWrapper>
    </StepsProvider>
  );
};

export default UnderExternalAdministration;
